<div class="table table-striped">
  <p-table #dt [value]="infoIdentidades" [rows]="10" [paginator]="true" [globalFilterFields]="['claseDocumentoNavigation.descripcion']"
            [rowHover]="true" dataKey="id"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} Info Identidades" [showCurrentPageReport]="true">
    <ng-template pTemplate="caption">
      <div class="p-d-flex p-ai-center p-jc-between">
        <span class="p-input-icon-left">
          <!-- <i class="pi pi-search"></i> -->
          <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Buscar..." />
        </span>
        <span class="p-input-icon">
          Vigencias del  
          <input pInputText type="date" [(ngModel)]="filtroDesde" (ngModelChange)="onChangeFiltros()" style="text-align:center" [disabled]="agrupar">
          al  
          <input pInputText type="date" [(ngModel)]="filtroHasta" (ngModelChange)="onChangeFiltros()" style="text-align:center" [disabled]="agrupar">
        </span>
        <mat-slide-toggle color="primary" [(ngModel)]="agrupar" (ngModelChange)="onChangeAgrupamiento()">Agrupar</mat-slide-toggle>
        <button *ngIf="permisoEdicion" type="button" pButton pRipple pTooltip="Agregar" tooltipPosition="bottom" icon="pi pi-plus" class="btn btn-sm btn-primary pull-right" (click)='add()'></button>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th>Clase Documento</th>
        <th>Nro Documento</th>
        <th>País</th>
        <th>Autoridad</th>
        <th>Nro Emisión</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-infoIdentidad let-rowIndex="rowIndex">

      <tr>
        <td>{{infoIdentidad.claseDocumentoNavigation.descripcion}}</td>
        <td>{{infoIdentidad.docNro}}</td>
        <td>{{infoIdentidad.paisEmisorNavigation.descripcion}}</td>
        <td>{{infoIdentidad.autoridad}}</td>
        <td>{{infoIdentidad.nroEmision}}</td>
        <td>
          <button pButton pRipple pTooltip="Editar" tooltipPosition="bottom" icon="pi pi-pencil" class="btn btn-xs btn-warning" (click)="visualizarDetalle(infoIdentidad, rowIndex)"></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
